import isEmpty from 'lodash/isEmpty';

const getCommonData = (lang, offerId) => {
  lang = isEmpty(lang)? 'es': lang;
  return {
    customer_group: '',
    funnel_name: 'credit cards: pre-approved',
    page_business_line: 'rbwm',
    page_customer_group: (offerId === 'Grabaut_P_MB')? 'premier': 'basic',
    page_language: (lang === 'en')? 'en': `${lang.substring(0, 2)}_MX`,
    page_security_level: '30',
    site_section: 'ib',
  };
};

export default getCommonData;
